'use client';

import { motion } from 'framer-motion';
import { PortableText } from '@portabletext/react';

import type { PagePatrickAffiliateSchema } from '@/sanity/pages/PagePatrickAffiliateTemplate';
import { measuredRichText } from './richtext';
import FAQListNewWebsite from './FAQListNewWebsite';

const ease = [0.25, 0.1, 0.25, 1] as const;

/** "Frequently Asked Questions" — Figma 8841:2098 (desktop) / 8811:3062 (mobile). */
export default function FAQSection({
  data,
}: {
  data: PagePatrickAffiliateSchema;
}) {
  if (!data?.faqChip && !data?.faqHeading?.length && !data?.faqItems?.length)
    return null;

  return (
    <section className="relative w-full bg-white py-[8rem] lg:py-[16rem]">
      <div className="flex flex-col items-center mx-auto w-[min(80rem,calc(100%-4rem))] gap-[2rem] lg:gap-[3rem]">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.8, ease }}
          className="flex flex-col items-center gap-[1.25rem]"
        >
          {data?.faqChip && (
            <p className="m-0 italic text-center text-black font-blacker text-[1.875rem] leading-[1.5]">
              {data.faqChip}
            </p>
          )}
          {data?.faqHeading?.length > 0 && (
            <div className="richtext richtext-center prose-headings:text-black prose-headings:font-geist prose-headings:font-[600] prose-headings:leading-[1.15] prose-headings:text-[4.5rem] prose-headings:tracking-[-0.225rem] lg:prose-headings:text-[8rem] lg:prose-headings:tracking-[-0.4rem] lg:w-[62.5rem] [--hl-tracking:-0.03em] [--hl-dy:-0.4rem] lg:[--hl-dy:-0.55rem]">
              <PortableText
                value={data.faqHeading}
                components={measuredRichText}
              />
            </div>
          )}
        </motion.div>

        {data?.faqItems?.length > 0 && (
          <FAQListNewWebsite faq={data.faqItems} className="w-full" />
        )}
      </div>
    </section>
  );
}
